import * as React from "react";
const SvgPinShadow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 42.5, viewBox: "0 0 32 42", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 16, cy: 38, rx: 8, ry: 4, fill: "black", fillOpacity: 0.1, stroke: "none" }));
export default SvgPinShadow;
